import { TagTypeModel } from "../types"
import { AnyAction } from "redux"
import { FETCH_DATA_RESPONSE_TAGS, FETCH_DATA_RESPONSE_TAGS_ERR, FETCH_DATA_REQUEST_TAGS } from "./getTagsList"

interface TagsState {
    loading: boolean,
    tagsList: TagTypeModel[],
    error: string | null
}

const initialState: TagsState = {
    loading: true,
    tagsList: [],
    error: null
}

const getTagsReducer = (state = initialState, action: AnyAction): TagsState => {
    switch (action.type) {
        case FETCH_DATA_REQUEST_TAGS:
            return {...state, loading: true, error: null};
        case FETCH_DATA_RESPONSE_TAGS:
            return {...state, loading: false, tagsList: action.payload};
        case FETCH_DATA_RESPONSE_TAGS_ERR:
            return {...state, loading: false, error: action.payload};
        default:
            return state;
    }
}

export default getTagsReducer;